export class AccountModel {
  id: string;
  accountId: string;
  userId: string;
  empresaId: number;
  unidadeId: number;
  fantasia: string;
  razao: string;
  cnpj: string;
  email: string;
  telefone: string;
  contato: string;
  versao: string;
  demonstracao: boolean;
  backup: boolean;
  licenca: Date;
  created: Date;
  updated: Date;

  constructor(data?: Partial<AccountModel>) {
    Object.assign(this, data);
  }
}
